import { QueryClient } from '@tanstack/react-query';

/** react query 의 공통 설정을 할 수 있습니다. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
